(function() { module.exports = this["forms"]; }());


//////////////////
// WEBPACK FOOTER
// external "forms"
// module id = 25
// module chunks = 0